import React from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";
import CmTrophyApplicationsTable from "./CmTrophyApplicationsTable";

const CmTrophyApplicants = () => {
  return (
    <>
      <PageTitle activeMenu="Applicants" motherMenu="CM Trophy" />
      <CmTrophyApplicationsTable />
    </>
  );
};

export default CmTrophyApplicants;
